export const formSubmmitMapper = (key, data) => ({
  [`tgl_posting_realisasi_ppa_${key}`]:
    data?.postingRealisasiPPA?.tglPostingRealisasiPPA,
  jumlah: data?.postingRealisasiPPA?.jumlah,
  coa_debet: data?.postingRealisasiPPA?.coaDebet,
  coa_kredit: data?.postingRealisasiPPA?.coaKredit,
  [`id_realisasi_ppa_${key}`]: data?.postingRealisasiPPA?.idRealisasiPPA,
  keterangan_jurnal: data?.postingRealisasiPPA?.keteranganJurnal,
});
